import { Dispatch } from 'react';
import { CoreApi } from '../../../api/api.apiclient';
import { GetSupplierInfoAction, GET_SUPPLIER_INFO, PUT_SUPPLIER_INFO } from '../types/supplierinfo.types';
import { SupplierRequest } from '../../../api/core/core.types';
import {LOCALSTORAGE_ACTIVE_SUPPLIER} from '../../../types/app.index';
import {SupplierModel} from '../../../api/admin/admin.types';
import {STORE_ACTIVE_SUPPLIER} from '../../authentication/types/authentication.types';

export const getSupplierInfo = () => async (dispatch: Dispatch<GetSupplierInfoAction>) => {
  try {
    const response = await CoreApi.SupplierInfo.getSupplierInfo();
    dispatch({
      type: GET_SUPPLIER_INFO,
      payload: {
        supplierInfo: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_SUPPLIER_INFO,
      payload: {
        supplierInfo: null
      }
    });
  }
};

export const editSupplier = (code: string, request: SupplierRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.SupplierInfo.editSupplier(code, request);

  const storedActiveSupplierString = localStorage.getItem(LOCALSTORAGE_ACTIVE_SUPPLIER) ?? null;
  let storedActiveSupplier: SupplierModel | null = null;

  if (storedActiveSupplierString) {
    storedActiveSupplier = JSON.parse(storedActiveSupplierString);
  }
  if (storedActiveSupplier) {
    storedActiveSupplier.tableauLogin = response.data.tableauEmail;
    storedActiveSupplier.baseCurrencyCode = response.data.baseCurrencyCode;
    storedActiveSupplier.hasBookingWeb = response.data.hasBookingWeb;
    storedActiveSupplier.tableauInsightsUrl = response.data.tableauInsightsUrl;
    storedActiveSupplier.tableauBillingUrl = response.data.tableauBillingUrl;
    localStorage.setItem(LOCALSTORAGE_ACTIVE_SUPPLIER, JSON.stringify(storedActiveSupplier));
  }

  dispatch({
    type: STORE_ACTIVE_SUPPLIER,
    payload: {
      activeSupplier: storedActiveSupplier
    }
  });

  dispatch({
    type: PUT_SUPPLIER_INFO,
    payload: {
      selectedSupplierInfo: response.data
    }
  });

  return Promise.resolve();
};

export const triggerSupplierFullSync = (code: string) => async () => {
  await CoreApi.SupplierInfo.triggerSupplierFullSync(code);
};

export const getSupplierFullSyncStatus = (code: string) => async () => {
  const response = await CoreApi.SupplierInfo.getSupplierFullSyncStatus(code);

  return response.data;
};
